export default __webpack_public_path__ + "static/media/white-paper.4e16ad56.pdf";